import React, { ReactNode } from "react";
import { SideMenu } from "../SideMenu/SideMenu";
import {
  AutoBreadCrumbs,
  CommonsStore,
  ConfirmationDialog,
  Header,
  SideMenuItems,
  UserMenuProps
} from "../../index";
import { inject, observer } from "mobx-react";

export interface LayoutWithSideMenuInterface extends UserMenuProps {
  breadCrumbs?: ReactNode;
  logo?: any;
  headerTitle?: string;
  landingPageLink?: string;
  children: ReactNode;
  headerChildren?: ReactNode;
  commons?: CommonsStore;
}

export const LayoutWithSideMenu = inject("commons")(
  observer((props: LayoutWithSideMenuInterface) => {
    const {
      breadCrumbs,
      logo,
      headerTitle,
      children,
      landingPageLink,
      buttonConfig
    } = props;
    const commons = props.commons!;

    const onHamburgerClick = () => {
      commons.toggleSideMenuDrawerExpanded();
    };

    return (
      <>
        <SideMenu
          items={<SideMenuItems />}
          expanded={commons.sideMenuDrawerExpanded}
          header={
            <Header
              logoSrc={logo}
              mainTitle={headerTitle}
              hamburgerClick={onHamburgerClick}
              landingPageLink={landingPageLink}
              buttonConfig={buttonConfig}
            >
              {props.headerChildren}
            </Header>
          }
        >
          {breadCrumbs ? breadCrumbs : <AutoBreadCrumbs />}
          {children}
        </SideMenu>
        <ConfirmationDialog
          open={commons.dialogOpen}
          dialogProps={commons.dialogProps}
        />
      </>
    );
  })
);
